import * as RA from "fp-ts/ReadonlyArray";
import * as M from "@discovery/prelude/lib/data/maybe";
/** @deprecated */
export const safeNthItemRenderer = (i, l) => M.maybe(React.createElement(React.Fragment, null), (V) => React.createElement(V, { index: i, key: i }), RA.lookup(i, l));

